import formatNumber from "./formatNumber";

export default (value? : number, emptyPlaceholder : string = "-") : string => {
	if (value === undefined || value === null || isNaN(value)) {
		return emptyPlaceholder;
	}

	return `${formatNumber(value * 100)}%`;
}
